var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_25675",
    "data-name": "Grupo 25675",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.598,
    height: 29.518,
    viewBox: "0 0 24.598 29.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69577",
    "data-name": "Trazado 69577",
    d: "M63.576,10.361V8.609a8.609,8.609,0,1,0-17.219,0v1.751a6.149,6.149,0,0,0-3.69,5.628v7.38a6.157,6.157,0,0,0,6.15,6.15h12.3a6.157,6.157,0,0,0,6.15-6.15v-7.38A6.15,6.15,0,0,0,63.576,10.361ZM48.817,8.609a6.15,6.15,0,0,1,12.3,0v1.23h-12.3ZM64.806,23.369a3.69,3.69,0,0,1-3.69,3.69h-12.3a3.69,3.69,0,0,1-3.69-3.69v-7.38a3.69,3.69,0,0,1,3.69-3.69h12.3a3.69,3.69,0,0,1,3.69,3.69Z",
    transform: "translate(-42.667)",
    fill: "#003763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69578",
    "data-name": "Trazado 69578",
    d: "M235.9,298.667a1.23,1.23,0,0,0-1.23,1.23v2.46a1.23,1.23,0,1,0,2.46,0V299.9A1.23,1.23,0,0,0,235.9,298.667Z",
    transform: "translate(-223.598 -281.448)",
    fill: "#003763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLock);
export default __webpack_public_path__ + "static/media/Icono-Lock.3b9df8189a19f04611da97f970d33516.svg";
export { ForwardRef as ReactComponent };